module.exports = __webpack_public_path__ + "img/content@2x.8f7a9225.png";